import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Style from './navbarStyles.module.css'
import ThreatIntelSOC from './ThreatIntelSOC';
import ThreatIntelFeed from './ThreatIntelFeed';
import { THREAT_INTEL_CUST_LICENSE_CODE, PHISH_PROT_SUITE_CUST_LICENSE_CODE } from '../utilities/threatIntelCustomerUtils';
import { isGlobalView } from '../utilities/config'

class ThreatIntelligence extends Component {

    state = {
        selectedNavItem: this.props.location?.state?.selectedNavItem || 'SOC',
    }

    tabOptions = [
        { name: 'SOC', displayName: 'API', component: <ThreatIntelSOC /> },
        { name: 'Portal', displayName: 'Portal', component: <ThreatIntelFeed context="threat-intel" /> }
    ];

    checkAndRedirect = () => {
        if( ![THREAT_INTEL_CUST_LICENSE_CODE, PHISH_PROT_SUITE_CUST_LICENSE_CODE].includes(this.props.licenseType) ) {
            this.props.history.push(
                `${
                isGlobalView(this.props.selectedCustomer.organizationName)
                    ? '/tenants'
                    : '/customers'
                }/${this.props.selectedCustomer.id}/incidents`
            );
        }
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.selectedCustomer !== prevProps.selectedCustomer) {
            //redirect to incidents page if license type is not valid
            this.checkAndRedirect();
        }
    }

    componentDidMount = () => {
        if (this.props.selectedCustomer) {
            //redirect to incidents page if license type is not valid
            this.checkAndRedirect();
        } 
    }


    renderTab = () => {
    let { selectedNavItem } = this.state
        return this.tabOptions.find(option => option.name === selectedNavItem)?.component || null
    }

    handleSelectNavItem = (item) => {
        this.setState({
            selectedNavItem: item,
        })
    }

    render() {
        let { selectedNavItem } = this.state
        return (
                  <div>
                    <div className={`${Style.navbar} pl-4 d-flex`}>
                      {this.tabOptions.map(option => (
                        <div
                          key={option.name}
                          onClick={() => this.handleSelectNavItem(option.name)}
                          className={
                            `${Style.navbarFontStyle} ` +
                            `${
                              selectedNavItem === option.name
                                ? Style.navbarSelectedItemStyle
                                : ''
                            } d-flex align-items-center ml-5`
                          }
                        >
                          {option.displayName}
                        </div>
                      ))}
                    </div>
                    <div>{this.renderTab()}</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedCustomer : state.entities.customers.selected,
    licenseType: state.entities.customers.selected?.licenseType,
})
    


const mapDispatchToProps = (dispatch) => {
    return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThreatIntelligence))